import { FormEvent, useState } from 'react';
import { t } from '../hooks/useT';

interface GuessFormProps {
  onSubmit: (guess: string) => void;
  disabled?: boolean;
}

export function GuessForm({ onSubmit, disabled }: GuessFormProps) {
  const [value, setValue] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSubmit(trimmed);
    setValue('');
  };

  return (
    <div className="guess-wrap">
      <p className="guess-hint">{t('play.hint')}</p>
      <form className="guess-form" onSubmit={handleSubmit}>
      <label htmlFor="guess-input" className="sr-only">{t('play.placeholder')}</label>
      <input
        id="guess-input"
        type="text"
        autoComplete="off"
        autoCapitalize="off"
        spellCheck={false}
        placeholder={t('play.placeholder')}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
      />
      <button type="submit" disabled={disabled || !value.trim()}>
        {t('play.submit')}
      </button>
    </form>
    </div>
  );
}
